<template>
  <div class="common-attr">
    <section class="attr-main">
      <div class="left-panel">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" v-if="!global">
            <template slot="title">
              <h3 class="lp-title">模板属性设置</h3>
            </template>
            <div class="lp-body">
              <slot name="form"></slot>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2" v-if="!global">
            <template slot="title">
              <h3 class="lp-title">全局设置</h3>
            </template>
            <ul class="lp-body lp-form">
              <li class="lp-form-item">
                <label class="title">默认背景</label>
                <span class="c-flex-center right-content">
                    <color-input v-model="tplData.json.backgroundColor"></color-input>
                </span>
              </li>
              <li class="lp-form-item" v-if="!isSingleTemplate">
                <label class="title">默认颜色</label>
                <el-input class="c-per-100 right-content" v-model="tplData.json.defaultTextColors"
                          placeholder="例：#ffffff,#ff00ff"
                          size="small"></el-input>
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item name="4" v-if="!global">
            <template slot="title">
              <h3 class="lp-title">联系方式</h3>
            </template>
            <ul class="lp-body lp-form">
              <li class="lp-form-item">
                <label class="title">POPO邮箱</label>
                <span class="c-flex-center right-content">
                    <el-input v-model="tplData.json.contactsNum"></el-input>
                </span>
              </li>
              <li class="lp-form-item">
                <label class="title">POPO标题</label>
                <span class="c-flex-center right-content">
                    <el-input v-model="tplData.json.contactsTitle" :maxlength="15"></el-input>
                </span>
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item name="3" class="tree-box">
            <template slot="title">
              <h3 class="lp-title">图层目录</h3>
            </template>
            <div class="lp-body tree-box">
              <tree-panel :global="global" v-model="treeData" :tplData="tplData"
                          @onItemClick="onItemClick"></tree-panel>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="center-panel" :class="{'vertical-center': verticalCenter}"
           :style="rightPanelVisible ? 'margin-right: 350px':'margin-right: 0px;'" @click="onMainClick">
        <div class="main-tpl">
          <slot name="main" :scale="scale"></slot>
        </div>
      </div>
      <right-panel @onItemClick="onItemClick" @onExtendImg="onExtendImg" class="right-panel" :global="global"
                   :style="rightPanelVisible ? 'transform: translateX(0px); overflow-y: hidden;': 'transform: translateX(350px)'"
                   :tplData="tplData" :tplModules="tplModules"></right-panel>
    </section>
    <scale-tools v-model="scale" :default-scale="defaultScale" :z-index="11" :y="70" :key="`st${refreshScaleToolsKey}`"></scale-tools>
  </div>
</template>
<script>
    import treePanel from './tree-panel';
    import rightPanel from './right-panel';
    import util from '@/util'
    import scaleTools from '../../components/scale-tools/index'
    import {template_type_single} from '@/const.js';
    import colorInput from '../../components/color-input'

    export default {
        components: {treePanel, rightPanel, scaleTools, colorInput},
        props: {
            tplData: Object,
            tplModules: Array,
            treeData: Array,
            loading: Boolean,
            global: Boolean,
        },
        data() {
            return {
                defaultScale: 0.1,
                scale: 1,
                verticalCenter: false,
                refreshScaleToolsKey: 0
            }
        },
        computed: {
            dialogValue: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                },
            },
            rightPanelVisible() {
                return this.tplData;
            },
            isSingleTemplate() {
                return this.tplData.type === template_type_single;
            },
            activeNames: {
                get() {
                    return this.$store.state.templateGroup.leftActiveNames;
                },
                set(v) {
                    this.$store.commit('templateGroup/set_left_active_name', v);
                },
            },
        },
        beforeDestroy(){
            this.removeEvent();
        },
        created() {
            this.init();
        },
        mounted() {
        },
        methods: {
            init() {
                this.setScale();
                this.bindEvent();
            },
            bindEvent(){
                window.addEventListener('resize', this.windResize);
            },
            removeEvent(){
                window.removeEventListener('resize', this.windResize);
            },
            setScale() {
                let {width, height} = this.tplData.json;
                let maxHeight = window.innerHeight - 64 - 40;
                if (width) {
                    let maxWidth = window.innerWidth - 350 * 2 - 60;
                    let scale = util.getScaleWidthAndHeight(maxWidth, maxHeight, width, height);
                    this.scale = scale < 0.2 ? 0.2 : scale;
                    this.defaultScale = this.scale;
                }
                this.verticalCenter = height < maxHeight;
            },
            windResize() {
                if (this.resizeTimeoutVal) {
                    return;
                }
                this.resizeTimeoutVal = setTimeout(() => {
                     this.refreshScaleToolsKey += 1;
                    this.resizeTimeoutVal = null;
                }, 300);
            },
            onItemClick(item) {
                this.$emit('onItemClick', item);
            },
            openColorPicker() {
                this.$refs.colorRef.$el.querySelector('.el-color-picker__icon').click();
            },
            onBgColorChange(value) {
                this.tplData.json.backgroundColor = value;
            },
            onExtendImg(value) {
                this.$emit('onExtendImg', value)
            },
            onMainClick() {
                let item = this.$store.state.templateGroup.selectedItem;
                if(item){
                    this.$emit('onItemClick', null);
                }
            }
        }
    }
</script>
<style lang="scss">
  @import "common-attr";
</style>